
import $ from "jquery"
import Promise from "plugins/bluebird/index"

const $class_name_on_expanded = "cell--listings--property-summary--box--sometimes-collapsed-style--expanded"
const selector = {
  main: ".cell--listings--property-summary--box--sometimes-collapsed-style",
  more: ".cell--listings--property-summary--box--sometimes-collapsed-style__btn-see-more",
  less: ".cell--listings--property-summary--box--sometimes-collapsed-style__btn-see-less",
}

const init_with_promise = () => {
  return new Promise((resolve, _reject) => {

    const $els = $(selector.main)
    if ($els.length === 0) { return }

    $els.each((idx, el) => {
      const $el = $(el)
      const $expand_button = $el.find(selector.more)
      const $collapse_button = $el.find(selector.less)

      if ($expand_button.length === 0) { return }

      $expand_button.on("click", () => {
        $el.addClass($class_name_on_expanded)
      })

      $collapse_button.on("click", () => {
        $el.removeClass($class_name_on_expanded)
      })
    })

    resolve()
  })
}

export default {init_with_promise}
